// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__g4ck-","noInteraction":"EventWrapper_noInteraction__1Ne5f","pointerPassthrough":"EventWrapper_pointerPassthrough__3T7tM"};